import { CustomerProfileResponse } from '../../../api/models/customer-profile-response';
import { TeamInvitationResponse } from '../../../services/team-management.service';
import { DEMO_CUSTOMER_PROFILE_ID } from '../demo-jwt';
import { DEMO_TEAM_MEMBERS } from './users.fixtures';

const NOW_ISO = new Date().toISOString();
const JOINED_ISO = new Date(Date.now() - 220 * 24 * 60 * 60 * 1000).toISOString();

/**
 * Backs GET /customer-profiles/{id}, read by both OrganizationService (navbar org
 * name, its own local `Organization` type) and TeamManagementService/UserManagement
 * page (`CustomerProfileResponse`) — both only read organizationName/industry/
 * maxUsers/currentUsersCount, so one fixture object satisfies both.
 */
export const DEMO_CUSTOMER_PROFILE: CustomerProfileResponse = {
  id: DEMO_CUSTOMER_PROFILE_ID,
  organizationName: 'Acme Mobile Co.',
  industry: 'Technology',
  country: 'United States',
  city: 'Austin',
  state: 'TX',
  contactEmail: 'demo-admin@app-doctor.io',
  contactPhone: '+1 (555) 010-0100',
  dataSharingOptIn: true,
  isActive: true,
  maxUsers: 10,
  currentUsersCount: DEMO_TEAM_MEMBERS.length,
  organizationType: 'BUSINESS',
  createdAt: JOINED_ISO,
  updatedAt: NOW_ISO
};

/** Seeds DemoStore.invitations — pending invites shown in the user-management page. */
export const DEMO_INVITATIONS: TeamInvitationResponse[] = [
  {
    id: 5001,
    email: 'sam.rivera@acmemobile.io',
    role: 'CUSTOMER_USER',
    status: 'PENDING',
    invitedByEmail: 'demo-admin@app-doctor.io',
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    expiresAt: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString()
  }
];
